import React from 'react';
import useAdmin from '~/hooks/useAdmin';

const StoreListProvider = ({ children }: { children: React.ReactElement }) => {
  useAdmin();
  return <>{children}</>;
};

export default StoreListProvider;
